import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from './ui/button';
import { Gift, CheckCircle, ArrowRight } from 'lucide-react';

const GiftSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [giftData, setGiftData] = useState(null);

  const giftId = searchParams.get('gift_id');

  useEffect(() => {
    if (giftId) processGift();
  }, [giftId]);

  const processGift = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/gift/process/${giftId}`, { method: 'POST' });
      const data = await res.json();
      setGiftData(data);
      setStatus(data.success ? 'success' : 'pending');
    } catch {
      setStatus('pending');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center px-4 py-12" data-testid="gift-success-page">
      <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 max-w-lg w-full text-center fade-in">
        {status === 'processing' ? (
          <>
            <div className="w-16 h-16 border-4 border-purple-200 border-t-purple-500 rounded-full animate-spin mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-gray-800 mb-3">Processing Your Gift...</h2>
            <p className="text-gray-600">We're sending the gift invitation email now.</p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Gift className="w-10 h-10 text-pink-500" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-3" data-testid="success-title">Gift Sent!</h2>
            <p className="text-gray-600 mb-6">
              The recipient will receive an email with a link to create their autobiography. What a thoughtful gift!
            </p>
            {giftData?.gift_code && (
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 mb-6">
                <p className="text-sm text-gray-500">Gift Code</p>
                <p className="text-2xl font-mono font-bold text-gray-800">{giftData.gift_code}</p>
              </div>
            )}
            <Button onClick={() => navigate('/')} className="w-full btn-primary text-white py-5 rounded-full border-0 font-semibold" data-testid="back-home-btn">
              Back to Home <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default GiftSuccess;
